import { Dispatch } from "redux";
import { createSlice } from "@reduxjs/toolkit";
// import { getAvailableLiquidity } from "./liquidity";
// import { getContractAllocation } from "./contract";
import {
  CUDOS_GAS_PRICE,
  DEFAULT_ESTIMATED_SWAP_TIME,
  DEFAULT_TOKEN_LOGO,
  TOKEN_TAG,
} from "../../utils/const.utils";
import { toast } from "react-hot-toast";
// import { Web3Helper } from "../../utils/web3/Web3Helper";
import { nonEvmCudosSwap } from "../../utils/web3/cudosHelpler";
import * as walletActions from "../slices/wallet";
import * as networkActions from "../slices/network";
import * as serverRequest from "../../_apis/SwapCrud";
import * as CABNApiRequest from "../../_apis/CABNCrud";
import Web3 from "web3";
import { Web3Helper } from "../../utils/web3/Web3Helper";
import { getFakeTokenCategorizedAndQuoteInformation } from "../../_apis/SwapCrud";

let token = localStorage.getItem(TOKEN_TAG);

export interface VERSION_HISTORY_INTERFACE {
  walletsVersion: number;
  networksVersion: number;
  cabnsVersion: number;
}

export interface SWAP_INITIAL_STATE {
  error: boolean;
  isLoading: boolean;
  isSwapping: boolean;
  isFetchingTokensList: boolean;
  isTokenQuoteLoading: boolean;
  isRegeneratingSwap: boolean;
  regeneratingSwapSystemStatus: string;
  regeneratingSwapChainStatus: string;
  tokenQuoteError: any;
  isSwapAndWithdrawTxsLoading: boolean;
  swapAndWithdrawError: boolean;
  swapAndWithdrawErrorMessage: string;
  toInfo: any;
  fromInfo: any;
  swapAndWithdrawTxList: any[];
  toNetworkTokenList: any[];
  fromNetworkTokenList: any[];
  sourceTokenCategorizedInfo: any;
  destinationTokenCategorizedInfo: any;
  fakeDestinationTokenCategorizedInfo: any;
  estimatedSwapTime: string;
  swapAndWithdrawTxStatus: string;
  showSwapAndWithdrawDialog: boolean;
  isSwappingScreenBlocked: boolean;
  swapProgressBarStatus: number;
  swapTransactionHash: string;
  withdrawTransactionHash: string;
  allTokens: any[];
  getTokensInfo: any[];
  versionHistory: VERSION_HISTORY_INTERFACE;
  isMobileModalVisible: boolean;
  swapGasFee: any;
  isSwapGasFeeLoading: boolean;
}

const initialState: SWAP_INITIAL_STATE = {
  error: false,
  isLoading: false,
  toInfo: {},
  fromInfo: {},
  isSwapping: false,
  isFetchingTokensList: false,
  isTokenQuoteLoading: false,
  isRegeneratingSwap: false,
  regeneratingSwapSystemStatus: "",
  regeneratingSwapChainStatus: "",
  tokenQuoteError: {},
  isSwapAndWithdrawTxsLoading: false,
  swapAndWithdrawError: false,
  swapAndWithdrawErrorMessage: "",
  swapAndWithdrawTxList: [],
  toNetworkTokenList: [],
  fromNetworkTokenList: [],
  sourceTokenCategorizedInfo: {
    type: "",
    sourceAmount: "",
    sourceSwapAmount: "",
  },
  destinationTokenCategorizedInfo: {
    type: "",
    destinationAmount: "",
    destinationSwapAmount: "",
    bridgeAmount: "",
  },
  fakeDestinationTokenCategorizedInfo: {},
  estimatedSwapTime: "",
  swapAndWithdrawTxStatus: "",
  showSwapAndWithdrawDialog: false,
  isSwappingScreenBlocked: false,
  swapProgressBarStatus: 0,
  swapTransactionHash: "",
  withdrawTransactionHash: "",
  allTokens: [],
  getTokensInfo: [],
  versionHistory: {
    walletsVersion: 0,
    networksVersion: 0,
    cabnsVersion: 0,
  },
  isMobileModalVisible: false,
  swapGasFee: {},
  isSwapGasFeeLoading: false,
};

const slice = createSlice({
  name: "swap",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    startFetchTradesLoading(state) {
      state.isSwapAndWithdrawTxsLoading = true;
    },
    startSwapping(state) {
      state.isSwapping = true;
      state.swapAndWithdrawError = false;
      state.swapAndWithdrawErrorMessage = "";
      state.swapAndWithdrawTxStatus = "";
      state.showSwapAndWithdrawDialog = true;
      state.swapProgressBarStatus = 0;
      state.isSwappingScreenBlocked = false;
      state.swapTransactionHash = "";
      state.withdrawTransactionHash = "";
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    swapToInfo(state, action) {
      state.isLoading = false;
      state.toInfo = action.payload.toInfo;
    },
    swapFromInfo(state, action) {
      state.isLoading = false;
      state.fromInfo = action.payload.fromInfo;
    },
    setTokenQuoteLoading(state, action) {
      state.isTokenQuoteLoading = action.payload;
    },
    switch(state, action) {
      const payload = action.payload;
      state.fromInfo = { ...payload.toInfo };
      state.toInfo = { ...payload.fromInfo };
    },
    setFromTokenList(state, action) {
      state.isLoading = false;
      state.fromNetworkTokenList = action.payload.fromNetworkTokenList;
    },
    setToTokenList(state, action) {
      state.isLoading = false;
      state.toNetworkTokenList = action.payload.toNetworkTokenList;
    },
    setSwapAndWithdrawTxList(state, action) {
      state.isSwapAndWithdrawTxsLoading = false;
      state.swapAndWithdrawTxList = action.payload.swapAndWithdrawTxList;
    },
    setTokenQuoteError(state, actions) {
      state.tokenQuoteError = actions.payload;
      state.isTokenQuoteLoading = false;
      // state.sourceTokenCategorizedInfo =
      //   initialState.sourceTokenCategorizedInfo;
      // state.destinationTokenCategorizedInfo =
      //   initialState.destinationTokenCategorizedInfo;
    },
    setSourceAndDestinationTokenCategorizedInfo(state, action) {
      state.sourceTokenCategorizedInfo =
        action.payload.sourceTokenCategorizedInfo;
      state.destinationTokenCategorizedInfo =
        action.payload.destinationTokenCategorizedInfo;
      state.fakeDestinationTokenCategorizedInfo =
        action.payload.fakeDestinationTokenCategorizedInfo;
      state.tokenQuoteError = undefined;
      state.isTokenQuoteLoading = false;
    },
    resetSourceAndDestinationTokenCategorizedInfo(state) {
      state.tokenQuoteError = undefined;
      state.sourceTokenCategorizedInfo =
        initialState.sourceTokenCategorizedInfo;
      state.destinationTokenCategorizedInfo =
        initialState.destinationTokenCategorizedInfo;
    },
    setSwapTxHash(state, action) {
      state.swapTransactionHash = action.payload;
    },
    setSwappingScreenBlocked(state) {
      state.isSwappingScreenBlocked = true;
    },
    setSwapAndWithdrawDialog(state, action) {
      state.showSwapAndWithdrawDialog = action.payload;
    },
    resetIsSwapping(state) {
      state.isSwapping = false;
    },
    setWithdrawTxHash(state, action) {
      state.withdrawTransactionHash = action.payload;
      state.isSwappingScreenBlocked = false;
    },
    setSwapAndWithdrawTxStatus(state, action) {
      state.swapAndWithdrawTxStatus = action.payload;
      state.swapProgressBarStatus = 0;
    },
    setSwapProgressBarStatus(state, action) {
      state.swapProgressBarStatus = action.payload;
    },
    catchSwapAndWithdrawError(state, action) {
      console.log("action: " + action.payload);
      state.swapAndWithdrawError = true;
      state.swapAndWithdrawErrorMessage = action.payload;
      state.showSwapAndWithdrawDialog = true;
      state.isSwappingScreenBlocked = false;
      state.isSwapping = false;
      state.swapProgressBarStatus = 0;
    },
    resetSourceAmount: (state) => {
      state.sourceTokenCategorizedInfo = {
        type: state.sourceTokenCategorizedInfo.type,
        sourceAmount: "",
      };
    },
    resetDestinationAmount: (state) => {
      state.destinationTokenCategorizedInfo = {};
    },
    setSwapTime: (state, action) => {
      state.estimatedSwapTime = action.payload;
    },
    setSwapGasFeeLoading: (state, action) => {
      state.isSwapGasFeeLoading = action.payload;
    },
    setSwapGasFee: (state, action) => {
      state.swapGasFee = action.payload;
    },
    setAllTokens: (state, action) => {
      state.allTokens = action.payload;
    },
    resetSwapTime: (state) => {
      state.estimatedSwapTime = "";
    },
    makeAnotherSwap(state) {
      state.error = false;
      state.isLoading = false;
      state.isSwapping = false;
      state.isSwapAndWithdrawTxsLoading = false;
      state.swapAndWithdrawError = false;
      state.swapAndWithdrawErrorMessage = "";
      state.swapAndWithdrawTxStatus = "";
      state.showSwapAndWithdrawDialog = false;
      state.swapProgressBarStatus = 0;
      state.swapTransactionHash = "";
      state.withdrawTransactionHash = "";
      state.swapGasFee = {};
    },
    resetSwapState(state) {
      state.isLoading = false;
      state.isSwapping = false;
      state.isSwapAndWithdrawTxsLoading = false;
      state.toNetworkTokenList = [];
      state.fromNetworkTokenList = [];
    },
    setRegeneratingSwap(state, action) {
      state.isRegeneratingSwap = action.payload;
    },
    setRegenerateSwapTxStatus(state, action) {
      state.regeneratingSwapSystemStatus = action.payload.systemStatus;
      state.regeneratingSwapChainStatus = action.payload.onChainStatus;
    },
    setIsFetchingTokensList: (state, action) => {
      state.isFetchingTokensList = action.payload;
    },
    setVersionHistory: (state, action) => {
      state.versionHistory = action.payload;
    },
    setMobileModalState: (state, action) => {
      state.isMobileModalVisible = action.payload;
    },
  },
});
export const { catchSwapAndWithdrawError } = slice.actions;

export default slice.reducer;

// =========================Actions===========================

const quoteStack: any = [];

const delay = (ms: any) => new Promise((res) => setTimeout(res, ms));

export const setToInfo = (toInfo: object) => (dispatch: Dispatch) => {
  dispatch(slice.actions.swapToInfo({ toInfo }));
};

export const setFromInfo = (fromInfo: object) => (dispatch: Dispatch) => {
  dispatch(slice.actions.swapFromInfo({ fromInfo }));
};

export const performSwap =
  (
    walletAddress: string,
    fromInfo: any,
    toInfo: any,
    amount: string,
    destinationAddress: string,
    slippage: string,
    sourceTokenCategorizedInfo: any,
    destinationTokenCategorizedInfo: any,
    fakeDestinationTokenCategorizedInfo: any,
    swapGasFee: any,
    sendTransaction: any
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(slice.actions.startSwapping());
      let response = await serverRequest.getSwapApi(
        walletAddress,
        fromInfo?.token?.address,
        fromInfo?.network?.chainId,
        sourceTokenCategorizedInfo.type,
        amount,
        sourceTokenCategorizedInfo.sourceBridgeAmount,
        sourceTokenCategorizedInfo.sourceOneInchData,
        sourceTokenCategorizedInfo.sourceOneInchSelector,
        destinationAddress,
        toInfo?.token?.address,
        toInfo?.network?.chainId,
        destinationTokenCategorizedInfo?.type,
        destinationTokenCategorizedInfo?.destinationOneInchData,
        destinationTokenCategorizedInfo?.destinationAmountIn,
        destinationTokenCategorizedInfo?.destinationAmountOut,
        destinationTokenCategorizedInfo?.destinationAmount,
        swapGasFee?.destination?.gasPriceInMachine
      );

      if (response) {
        let transaction = response.data.body.data;
        const payload = {
          from: transaction.from,
          to: transaction.contract,
          data: transaction.data,
          value: transaction.value
            ? Web3?.utils.toHex(transaction.value)
            : transaction.value,
        };
        sendTransaction(payload);
      }
    } catch (err: any) {
      console.log(err);
      console.log("err", err);
      let message: any =
        err?.response?.data?.status?.message?.error ||
        err?.response?.data?.body?.message ||
        err?.message ||
        err;

      if (JSON.stringify(message)?.includes("reverted by the EVM")) {
        message = "Transaction has been reverted by the EVM";
      } else if (JSON.stringify(message).includes("rpc error")) {
        console.log(message.split(","));
        message =
          message.split(",")[6].split(":")[1].replace("}", "").trim() ||
          "Something went wrong";
      }
      dispatch(slice.actions.catchSwapAndWithdrawError(message));
      return;
    }
  };

// export const performNonEvmSwap =
//   (
//     fromInfo: any,
//     toInfo: any,
//     amount: string,
//     destinationAddress: string,
//     keplrWalletAddress: string,
//     CosmWasmClient: any
//   ) =>
//   async (dispatch: Dispatch) => {
//     try {
//       dispatch(slice.actions.startSwapping());
//       const { destinationTokenCategorizedInfo, sourceTokenCategorizedInfo } =
//         await getTokenCategorizedInformation(
//           keplrWalletAddress,
//           fromInfo?.token?.address,
//           fromInfo?.network?.chainId,
//           amount,
//           destinationAddress,
//           toInfo?.token?.address,
//           toInfo?.network?.chainId
//         )(dispatch);
//       const tx = await nonEvmCudosSwap(
//         fromInfo?.token?.address,
//         (Number(amount) * 1000000000000000000).toString(),
//         destinationTokenCategorizedInfo.destinationBridgeAmount,
//         toInfo?.network?.chainId,
//         toInfo?.token?.address,
//         destinationAddress,
//         keplrWalletAddress,
//         CosmWasmClient,
//         CUDOS_GAS_PRICE,
//         fromInfo?.network?.multiSwapFiberRouterSmartContractAddress
//       );
//       console.log({ tx });
//       // if (tx) {
//       //   dispatch(slice.actions.setSwapTxHash(tx.transactionHash));
//       //   swapAndWithdraw(
//       //     tx.transactionHash,
//       //     fromInfo,
//       //     toInfo,
//       //     amount,
//       //     sourceTokenCategorizedInfo,
//       //     destinationTokenCategorizedInfo
//       //   )(dispatch);
//       // }
//     } catch (e: any) {
//       console.log(e);
//       console.log(e?.message);
//       const message =
//         e?.response?.data?.status?.message?.error ||
//         e?.response?.data?.body?.message ||
//         e?.message ||
//         e ||
//         "Something went wrong";
//       dispatch(slice.actions.catchSwapAndWithdrawError(message));
//     }
//   };

export const swapAndWithdraw =
  (
    txId: any,
    fromInfo: any,
    toInfo: any,
    amount: string,
    swapGasFee: any,
    slippage: string,
    sourceTokenCategorizedInfo: any,
    destinationTokenCategorizedInfo: any,
    fakeDestinationTokenCategorizedInfo: any
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(slice.actions.setSwapTxHash(txId));
      let txStatus = "";
      while (txStatus !== "swapWithdrawCompleted") {
        const txReceipt = await serverRequest.doSwapAndWithdrawTxAfterSwapApi(
          txId,
          fromInfo?.network?._id,
          fromInfo?.token?.cabnId,
          sourceTokenCategorizedInfo?.type,
          amount,
          sourceTokenCategorizedInfo?.sourceBridgeAmount,
          sourceTokenCategorizedInfo.sourceOneInchData,
          sourceTokenCategorizedInfo.sourceOneInchSelector,
          toInfo?.network?._id,
          toInfo?.token?.cabnId,
          destinationTokenCategorizedInfo?.type,
          destinationTokenCategorizedInfo.destinationOneInchData,
          destinationTokenCategorizedInfo.destinationAmountIn,
          destinationTokenCategorizedInfo.destinationAmountOut,
          fakeDestinationTokenCategorizedInfo.destinationOneInchSelector,
          swapGasFee,
          slippage
        );
        const transactionReceipt =
          txReceipt?.data?.body?.swapAndWithdrawTransaction?.status;
        await delay(2000);
        dispatch(slice.actions.resetIsSwapping());
        dispatch(slice.actions.setSwapAndWithdrawTxStatus(transactionReceipt));
        txStatus = transactionReceipt;
        if (transactionReceipt === "swapPending") {
          dispatch(slice.actions.setSwapProgressBarStatus(26));
        } else if (transactionReceipt === "swapCompleted") {
          dispatch(slice.actions.setSwapProgressBarStatus(40));
        } else if (transactionReceipt === "swapWithdrawPending") {
          // dispatch(slice.actions.setSwapAndWithdrawDialog(false));
          // dispatch(slice.actions.setSwappingScreenBlocked());
          dispatch(slice.actions.setSwapProgressBarStatus(75));
        } else if (transactionReceipt === "swapWithdrawCompleted") {
          // dispatch(slice.actions.setSwapAndWithdrawDialog(true));
          dispatch(slice.actions.setSwapProgressBarStatus(100));
          dispatch(
            slice.actions.setWithdrawTxHash(
              txReceipt?.data?.body?.swapAndWithdrawTransaction?.withdrawTransactions?.shift()
                .transactionId
            )
          );
        }
        if (
          transactionReceipt === "swapFailed" ||
          transactionReceipt === "swapWithdrawFailed" ||
          transactionReceipt === "generatorSignatureFailed" ||
          transactionReceipt === "validatorSignatureFailed" ||
          transactionReceipt === "masterValidationFailed"
        ) {
          dispatch(slice.actions.setSwapProgressBarStatus(0));
          dispatch(
            slice.actions.setSwapAndWithdrawTxStatus(transactionReceipt)
          );
          break;
        }
        if (transactionReceipt === "swapWithdrawCompleted") {
          break;
        }
      }
    } catch (e: any) {
      console.log(e?.response);
      const message =
        e?.response?.data?.status?.message?.error ||
        e?.response?.data?.body?.message;
      dispatch(slice.actions.catchSwapAndWithdrawError(message));
      toast.error(e.message);
    }
  };

export const setFromTokens = (tokens: any[]) => (dispatch: Dispatch) => {
  dispatch(slice.actions.setFromTokenList({ fromNetworkTokenList: tokens }));
};

export const exchangeSwapInfo =
  (fromInfo: object, toInfo: any) => (dispatch: any) => {
    dispatch(slice.actions.switch({ toInfo, fromInfo }));
  };

export const setToTokens = (tokens: any[]) => (dispatch: Dispatch) => {
  dispatch(slice.actions.setToTokenList({ toNetworkTokenList: tokens }));
};

export const getSwapAndWithdrawTransactions =
  (offset: any, tx: string) => (dispatch: Dispatch) => {
    dispatch(slice.actions.startFetchTradesLoading());
    serverRequest
      .getAllSwapAndWithdrawTransactionsApi(offset, tx)
      .then((res) => {
        const { swapAndWithdrawTransactions } = res.data.body;
        dispatch(
          slice.actions.setSwapAndWithdrawTxList({
            swapAndWithdrawTxList: swapAndWithdrawTransactions,
          })
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

export const resetToAndFromState = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.resetSwapState());
};

export const getTokenCategorizedInformation =
  (
    sourceWalletAddress: string,
    sourceTokenContractAddress: string,
    sourceNetworkChainId: string,
    sourceAmount: string,
    destinationAddress: string,
    destinationTokenContractAddress: string,
    destinationNetworkChainId: string,
    slippage: string,
    isApprovedToGetGasFee: boolean
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(slice.actions.resetSourceAndDestinationTokenCategorizedInfo());
      dispatch(slice.actions.setTokenQuoteLoading(true));
      quoteStack.push(sourceAmount);
      const response =
        await serverRequest.getTokenCategorizedAndQuoteInformation(
          sourceWalletAddress,
          sourceTokenContractAddress,
          sourceNetworkChainId,
          sourceAmount,
          destinationAddress,
          destinationTokenContractAddress,
          destinationNetworkChainId,
          slippage
        );
      const { sourceTokenCategorizedInfo, destinationTokenCategorizedInfo } =
        response?.data?.body?.data;
      let fakeDestinationTokenCategorizedInfo;
      if (isApprovedToGetGasFee) {
        const tokenQuoteFakeResponse: any =
          await serverRequest.getFakeTokenCategorizedAndQuoteInformation(
            sourceWalletAddress,
            sourceTokenContractAddress,
            sourceNetworkChainId,
            sourceAmount,
            destinationAddress,
            destinationTokenContractAddress,
            destinationNetworkChainId,
            slippage,
            "0.5"
          );
        fakeDestinationTokenCategorizedInfo =
          tokenQuoteFakeResponse?.data?.body?.data
            ?.destinationTokenCategorizedInfo;
      }
      if (
        response &&
        String(sourceTokenCategorizedInfo?.sourceAmount) ===
          String(quoteStack[quoteStack.length - 1])
      ) {
        dispatch(
          slice.actions.setSourceAndDestinationTokenCategorizedInfo({
            sourceTokenCategorizedInfo,
            destinationTokenCategorizedInfo,
            fakeDestinationTokenCategorizedInfo,
          })
        );
      }

      if (isApprovedToGetGasFee) {
        dispatch(slice.actions.setSwapGasFeeLoading(true));
        const gasFeeData = await serverRequest.getGasFee(
          sourceNetworkChainId,
          sourceTokenContractAddress,
          sourceAmount,
          sourceTokenCategorizedInfo?.sourceBridgeAmount,
          sourceTokenCategorizedInfo?.sourceOneInchData,
          sourceTokenCategorizedInfo?.type,
          sourceTokenCategorizedInfo?.sourceOneInchSelector,
          sourceWalletAddress,
          destinationNetworkChainId,
          destinationTokenContractAddress,
          fakeDestinationTokenCategorizedInfo?.destinationOneInchSelector,
          fakeDestinationTokenCategorizedInfo?.destinationAmountIn,
          fakeDestinationTokenCategorizedInfo?.destinationAmountOut,
          fakeDestinationTokenCategorizedInfo?.destinationOneInchData,
          fakeDestinationTokenCategorizedInfo?.type,
          destinationAddress ? destinationAddress : sourceWalletAddress
        );

        dispatch(slice.actions.setSwapGasFee(gasFeeData?.data?.body));
        dispatch(slice.actions.setSwapGasFeeLoading(false));
      }
      return response?.data?.body?.data;
    } catch (error: any) {
      console.log({ error });
      console.log({ error: error?.response?.data });
      dispatch(slice.actions.setSwapGasFeeLoading(false));
      dispatch(
        slice.actions.setTokenQuoteError(error?.response?.data?.status?.message)
      );
      toast.error(`${error?.response?.data?.status?.message}`);
      return;
    }
  };

export const resetSourceAmount = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.resetSourceAmount());
};

export const resetDestinationAmount = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.resetDestinationAmount());
};

export const getEstimatedSwapTime =
  (sourceNetworkId: any, destinationNetworkId: any) => (dispatch: Dispatch) => {
    return serverRequest
      .getEstimatedSwapTime(sourceNetworkId, destinationNetworkId)
      .then((res) => {
        if (res?.data?.body?.estimatedSwapTimeByNetwork?.time) {
          dispatch(
            slice.actions.setSwapTime(
              res?.data?.body?.estimatedSwapTimeByNetwork?.time
            )
          );
        } else {
          dispatch(slice.actions.setSwapTime(DEFAULT_ESTIMATED_SWAP_TIME));
        }
      })
      .catch((e) => {
        console.log(e);
        toast.error(e?.response?.data?.body?.message);
      });
  };

export const makeAnotherSwap = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.makeAnotherSwap());
};

export const closeSwapAndWithdrawDialog = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.setSwapAndWithdrawDialog(false));
};

export const getAllTokens =
  (authToken: string) => async (dispatch: Dispatch) => {
    const response = await CABNApiRequest.getCABNsList({
      limit: 100,
      priority: true,
    });
    dispatch(
      slice.actions.setAllTokens(
        response?.data?.body?.currencyAddressesByNetworks
      )
    );
    return response?.data?.body?.currencyAddressesByNetworks;
  };

export const updateFromInfoToken =
  (
    tokens: any[],
    network: any,
    currency: string,
    direction: string,
    authToken: string
  ) =>
  async (dispatch: Dispatch) => {
    let token: any;
    tokens.forEach((item: any) => {
      if (
        item?.tokenContractAddress === currency &&
        Number(network?.chainId) === Number(item?.network.chainId)
      ) {
        token = {
          name: item?.isDefault
            ? item.currency?.name
            : item?.nonDefaultCurrencyInformation?.name,
          logoURI: item?.isDefault ? item.currency?.logo : DEFAULT_TOKEN_LOGO,
          symbol: item?.isDefault
            ? item.currency?.symbol
            : item?.nonDefaultCurrencyInformation?.symbol,
          chainId: Number(item?.network.chainId),
          address: item?.tokenContractAddress,
          currency: item?.tokenContractAddress,
          decimals: item?.decimals,
          isNative: item?.isNative,
          cabnId: item?._id,
        };
      }
    });
    if (!token && currency) {
      const cabnListParameters = {
        priority: true,
        chainId: network?.chainId,
        tokenContractAddress: currency,
      };
      const response = (
        await CABNApiRequest.getCABNsList(cabnListParameters)
      ).data?.body?.currencyAddressesByNetworks?.shift();
      token = {
        name: response?.isDefault
          ? response.currency?.name
          : response?.nonDefaultCurrencyInformation?.name,
        logoURI: response?.isDefault
          ? response.currency?.logo
          : DEFAULT_TOKEN_LOGO,
        symbol: response?.isDefault
          ? response.currency?.symbol
          : response?.nonDefaultCurrencyInformation?.symbol,
        chainId: Number(response?.network.chainId),
        address: response?.tokenContractAddress,
        currency: response?.tokenContractAddress,
        decimals: response?.decimals,
        isNative: response?.isNative,
        cabnId: response?._id,
      };
    }
    if (direction === "FROM") {
      setFromInfo({ network, token })(dispatch);
    } else if (direction === "TO") {
      setToInfo({ network, token })(dispatch);
    }
  };

export const getTokenList =
  (
    cachedTokens: any,
    network: any,
    selectorDialogFor: string,
    fromInfo: any,
    toInfo: any,
    walletAddress: any,
    token: any,
    searchValue: string,
    authToken: string
  ) =>
  async (dispatch: Dispatch) => {
    let tokens: any = [];
    if (network) {
      try {
        if (
          selectorDialogFor === "FROM_NETWORK" ||
          selectorDialogFor === "FROM_TOKEN"
        ) {
          let fromInfoData = {
            network: {
              ...network,
              networkName: network.networkName,
              image: network.image,
              fromNetworkId: network._id,
            },
            token: token,
          };
          setFromInfo(fromInfoData)(dispatch);
        } else if (
          selectorDialogFor === "TO_NETWORK" ||
          selectorDialogFor === "TO_TOKEN"
        ) {
          let toInfoData = {
            network: {
              ...network,
              networkName: network.networkName,
              image: network.image,
              fromNetworkId: network._id,
            },
            token: token,
          };
          setToInfo(toInfoData)(dispatch);
        }
        const web3 = new Web3(network?.rpcUrl);
        const web3Helper = new Web3Helper(web3);
        dispatch(slice.actions.setIsFetchingTokensList(true));
        if (searchValue) {
          tokens = cachedTokens?.filter(
            (token: any) =>
              token?.network?._id === network?._id && token.name === searchValue
          );
        } else {
          tokens = cachedTokens?.filter(
            (token: any) => token?.network?._id === network?._id
          );
        }
        if (!tokens?.length) {
          const cabnListParameters = {
            networkId: network?._id,
            priority: true,
            search: searchValue,
          };

          const response = await CABNApiRequest.getCABNsList(
            cabnListParameters
          );
          tokens = response?.data?.body?.currencyAddressesByNetworks;
        }
        if (!tokens.length && Web3.utils.isAddress(searchValue)) {
          const data = await web3Helper.fetchTokenDetail(searchValue);
          if (data) {
            const response: any = await CABNApiRequest.createUserCustomCABN({
              tokenContractAddress: data?.tokenAddress.toLowerCase(),
              chainId: network?.chainId,
              currencyName: data?.name,
              currencySymbol: data?.symbol,
              decimals: Number(data?.decimals),
            });

            if (response) {
              const cabnListParameters = {
                networkId: network?._id,
                priority: true,
                search: searchValue,
              };
              await new Promise((resolve) => setTimeout(resolve, 2000));
              const response = await CABNApiRequest.getCABNsList(
                cabnListParameters
              );

              tokens = response?.data?.body?.currencyAddressesByNetworks;
            }
          }
        }
        let tokensData: any = [];
        const balances: any = {};
        for (const token of tokens) {
          if (token?.isNative) {
            const balance = await web3Helper.fetchNativeTokenBalance(
              walletAddress
            );
            balances[token.tokenContractAddress] = balance;
          } else {
            const balance = await web3Helper.fetchTokenBalance(
              token?.tokenContractAddress,
              walletAddress
            );
            balances[token.tokenContractAddress] = balance;
          }
        }
        if (tokens?.length) {
          tokensData = tokens
            .map((item: any) => {
              if (
                item?.network?._id === network?._id &&
                item?.isAllowedOnMultiSwap
              ) {
                return {
                  name: item?.isDefault
                    ? item.currency?.name
                    : item?.nonDefaultCurrencyInformation?.name,
                  logoURI: item?.isDefault
                    ? item.currency?.logo
                    : DEFAULT_TOKEN_LOGO,
                  symbol: item?.isDefault
                    ? item.currency?.symbol
                    : item?.nonDefaultCurrencyInformation?.symbol,
                  chainId: Number(item?.network.chainId),
                  address: item?.tokenContractAddress,
                  currency: item?.tokenContractAddress,
                  decimals: item?.decimals,
                  isNative: item?.isNative,
                  cabnId: item?._id,
                  balance: balances[item.tokenContractAddress],
                };
              }
            })
            .sort((a: any, b: any) => b.balance - a.balance);
          dispatch(slice.actions.setIsFetchingTokensList(false));
          if (
            selectorDialogFor === "FROM_NETWORK" ||
            selectorDialogFor === "FROM_TOKEN"
          ) {
            setFromTokens([...tokensData])(dispatch);
            let fromInfoData = {
              network: {
                ...network,
                networkName: network.networkName,
                image: network.image,
                fromNetworkId: network._id,
              },
              token: token,
            };
            setFromInfo(fromInfoData)(dispatch);
          } else if (
            selectorDialogFor === "TO_NETWORK" ||
            selectorDialogFor === "TO_TOKEN"
          ) {
            setToTokens([...tokensData])(dispatch);
            let toInfoData = {
              network: {
                ...network,
                networkName: network.networkName,
                image: network.image,
                fromNetworkId: network._id,
              },
              token: token,
            };
            setToInfo(toInfoData)(dispatch);
          }
        } else {
          // no tokens so empty the list
          if (
            selectorDialogFor === "FROM_NETWORK" ||
            selectorDialogFor === "FROM_TOKEN"
          ) {
            setFromTokens([])(dispatch);
            setFromInfo({
              network: {
                ...network,
                networkName: network.networkName,
                image: network.image,
                fromNetworkId: network._id,
              },
              token: token,
            })(dispatch);
          } else if (
            selectorDialogFor === "TO_NETWORK" ||
            selectorDialogFor === "TO_TOKEN"
          ) {
            // setQuoteLoading(true);
            setToTokens([])(dispatch);
            setToInfo({
              network: {
                ...network,
                networkName: network.networkName,
                image: network.image,
                fromNetworkId: network._id,
              },
              token: token,
            })(dispatch);
          }
        }
      } catch (e) {
        dispatch(slice.actions.setIsFetchingTokensList(false));
      }
    } else if (token) {
      if (
        (selectorDialogFor === "FROM_TOKEN" ||
          selectorDialogFor === "FROM_NETWORK") &&
        token
      ) {
        setFromInfo({ ...fromInfo, token })(dispatch);
      } else if (
        (selectorDialogFor === "TO_TOKEN" ||
          selectorDialogFor === "TO_NETWORK") &&
        token
      ) {
        // setQuoteLoading(true);
        setToInfo({ ...toInfo, token })(dispatch);
      }
    }
  };

export const resetSwapAndWithdrawStatus = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.setSwapAndWithdrawTxStatus(""));
};

export const getVersionHistory =
  (previousVersions: any) => async (dispatch: Dispatch) => {
    // let UpdateVersionState = false;
    // let response;
    // if (IS_MULTISWAP) {
    //   response = await CABNApiRequest.getVersionHistory();
    // }
    walletActions.getWalletList()(dispatch);
    networkActions.getNetworksList()(dispatch);
    // if (
    //   response?.data?.body?.versionHistory?.cabnsVersion !==
    //   previousVersions?.cabnsVersion
    // ) {
    //   setAllTokens()(dispatch);
    // getAllTokens()(dispatch);
    //   UpdateVersionState = true;
    // }
    // if (UpdateVersionState === true) {
    //   dispatch(
    //     slice.actions.setVersionHistory(response?.data?.body?.versionHistory)
    //   );
    // }
    return;
  };
export const regenerateSwap =
  (txHash: string, chainId: string) => async (dispatch: Dispatch) => {
    try {
      dispatch(slice.actions.setRegeneratingSwap(true));
      let onChainStatus, systemStatus;
      while (systemStatus !== "swapWithdrawCompleted") {
        const tx = await serverRequest.regenerateSwap(txHash, chainId);
        console.log({
          tx,
          "tx?.data?.body?.status?.message": tx?.data?.status?.message,
        });

        if (tx) {
          onChainStatus = tx?.data?.body?.onChainStatus;
          systemStatus = tx?.data?.body?.systemStatus;
          dispatch(slice.actions.setRegenerateSwapTxStatus(tx?.data?.body));
          dispatch(slice.actions.setRegeneratingSwap(false));
        }
        if (
          onChainStatus === "failed" ||
          systemStatus === "swapFailed" ||
          systemStatus === "swapWithdrawFailed" ||
          systemStatus === "generatorSignatureFailed" ||
          systemStatus === "validatorSignatureFailed" ||
          systemStatus === "masterValidationFailed"
        ) {
          break;
        }
        await delay(2000);
      }
    } catch (e: any) {
      console.log(e);
      dispatch(slice.actions.setRegeneratingSwap(false));
      const message =
        e?.response?.data?.status?.message?.error ||
        e?.response?.data?.body?.message;
      dispatch(slice.actions.catchSwapAndWithdrawError(message));
    }
  };

export const resetRegenerateSwap = () => (dispatch: Dispatch) => {
  dispatch(
    slice.actions.setRegenerateSwapTxStatus({
      systemStatus: "",
      onChainStatus: "",
    })
  );
};

export const resetSourceAndDestinationTokenCategorizedInfo =
  () => (dispatch: Dispatch) => {
    dispatch(slice.actions.resetSourceAndDestinationTokenCategorizedInfo());
  };
